import { useTheme } from "@mui/material/styles";
import Levis from "../assets/Levis.png";
export const Logo = () => {
  const theme = useTheme();
  const fillColor = theme.palette.primary.main;

  return <img src={Levis} style={{ height: 40 }} />;
};
